import '../App.css';
import React, { useEffect } from 'react';

/* ─── Animated Pokéball ─────────────────────────────────────────────────────── */
function HeroGraphic({ size = 180 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="110" cy="110" r="100" stroke="url(#ringGradLP)" strokeWidth="1.5" strokeDasharray="6 4" opacity="0.5"/>
      <circle cx="110" cy="110" r="84" stroke="rgba(200,168,75,0.15)" strokeWidth="1"/>
      <circle cx="110" cy="110" r="62" fill="rgba(20,26,40,0.9)" stroke="url(#ballGradLP)" strokeWidth="2.5"/>
      <path d="M48 110 A62 62 0 0 1 172 110 Z" fill="url(#topGradLP)" opacity="0.85"/>
      <rect x="48" y="106" width="124" height="8" fill="#0e1117"/>
      <rect x="48" y="107.5" width="124" height="1" fill="rgba(200,168,75,0.5)"/>
      <rect x="48" y="111.5" width="124" height="1" fill="rgba(200,168,75,0.5)"/>
      <circle cx="110" cy="110" r="14" fill="#0e1117" stroke="url(#btnGradLP)" strokeWidth="2.5"/>
      <circle cx="110" cy="110" r="8" fill="url(#innerBtnLP)"/>
      <circle cx="106" cy="106" r="2" fill="rgba(255,255,255,0.3)"/>
      {[0,60,120,180,240,300].map((deg, i) => {
        const r = 96;
        const x = 110 + r * Math.cos((deg * Math.PI) / 180);
        const y = 110 + r * Math.sin((deg * Math.PI) / 180);
        return <circle key={i} cx={x} cy={y} r="2" fill="#c8a84b" opacity={0.4 + (i % 3) * 0.2}/>;
      })}
      <path d="M140 58 L133 74 L139 74 L130 92 L145 72 L138 72 Z" fill="#f0d060" opacity="0.7"/>
      <path d="M78 130 L73 142 L77 142 L71 154 L82 138 L77 138 Z" fill="#c8a84b" opacity="0.5"/>
      <defs>
        <radialGradient id="ringGradLP" cx="50%" cy="50%">
          <stop offset="0%" stopColor="#c8a84b"/>
          <stop offset="100%" stopColor="#c8a84b" stopOpacity="0"/>
        </radialGradient>
        <linearGradient id="ballGradLP" x1="48" y1="48" x2="172" y2="172" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#c8a84b" stopOpacity="0.8"/>
          <stop offset="100%" stopColor="#604020" stopOpacity="0.4"/>
        </linearGradient>
        <linearGradient id="topGradLP" x1="48" y1="60" x2="172" y2="110" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#c83030"/>
          <stop offset="100%" stopColor="#803010"/>
        </linearGradient>
        <linearGradient id="btnGradLP" x1="96" y1="96" x2="124" y2="124" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#f0d060"/>
          <stop offset="100%" stopColor="#c8853a"/>
        </linearGradient>
        <radialGradient id="innerBtnLP" cx="40%" cy="35%">
          <stop offset="0%" stopColor="#f0e8d0"/>
          <stop offset="100%" stopColor="#a08060"/>
        </radialGradient>
      </defs>
    </svg>
  );
}

/* ─── Decorative type badge row ─────────────────────────────────────────────── */
const TYPE_BADGES = [
  { label: 'Normal',   colour: '#A8A878' },
  { label: 'Fire',     colour: '#F08030' },
  { label: 'Water',    colour: '#6890F0' },
  { label: 'Electric', colour: '#F8D030' },
  { label: 'Grass',    colour: '#78C850' },
  { label: 'Ice',      colour: '#98D8D8' },
  { label: 'Fighting', colour: '#C03028' },
  { label: 'Poison',   colour: '#A040A0' },
  { label: 'Ground',   colour: '#E0C068' },
  { label: 'Flying',   colour: '#A890F0' },
  { label: 'Psychic',  colour: '#F85888' },
  { label: 'Bug',      colour: '#A8B820' },
  { label: 'Rock',     colour: '#B8A038' },
  { label: 'Ghost',    colour: '#705898' },
  { label: 'Dragon',   colour: '#7038F8' },
  { label: 'Dark',     colour: '#705848' },
  { label: 'Steel',    colour: '#B8B8D0' },
  { label: 'Fairy',    colour: '#EE99AC' },
];

export default function Landingpage() {
  useEffect(() => {
    const nav = document.querySelector('.nav-bar');
    if (nav) nav.classList.add('hidden');
    return () => { if (nav) nav.classList.remove('hidden'); };
  }, []);

  return (
    <>
      <style>{`
        @keyframes floatBob {
          0%, 100% { transform: translateY(0px);   }
          50%       { transform: translateY(-14px); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0);    }
        }
        @keyframes badgeScroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .lp-btn-primary:hover {
          background: linear-gradient(135deg, #f0d060, #c8853a) !important;
          transform: translateY(-2px);
          box-shadow: 0 8px 28px rgba(200,168,75,0.4) !important;
        }
        .lp-btn-secondary:hover {
          background: rgba(200,168,75,0.12) !important;
          border-color: #c8a84b !important;
          color: #f0d060 !important;
          transform: translateY(-2px);
        }
        .lp-btn-primary, .lp-btn-secondary {
          transition: all 0.2s ease;
        }
        .lp-feature:hover {
          border-color: rgba(200,168,75,0.35) !important;
          background: rgba(200,168,75,0.05) !important;
        }
      `}</style>

      <div style={S.page}>
        {/* Grain */}
        <div style={S.grain} />

        {/* ── HERO ── */}
        <section style={S.hero}>
          <div style={S.ballWrap}>
            <HeroGraphic size={180} />
          </div>

          <p style={S.eyebrow}>The Ultimate Pokémon Challenge</p>

          <h1 style={S.title}>
            Fearless<br />Nuzlocke
          </h1>

          <p style={S.subtitle}>
            Monotype runs. Fearless Draft rules. Every Pokémon used once —
            <br />across all 18 types, across every generation.
          </p>

          <div style={S.btnRow}>
            <a href="/Login" className="lp-btn-primary" style={S.btnPrimary}>
              Start your run
            </a>
            <a href="/Rules" className="lp-btn-secondary" style={S.btnSecondary}>
              Read the rules
            </a>
          </div>
        </section>

        {/* ── Scrolling type badges ── */}
        <div style={S.badgeTrack}>
          <div style={S.badgeInner}>
            {[...TYPE_BADGES, ...TYPE_BADGES].map((t, i) => (
              <span key={i} style={{ ...S.badge, borderColor: t.colour, color: t.colour, background: `${t.colour}18` }}>
                {t.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

/* ─── Styles ─────────────────────────────────────────────────────────────────── */
const S = {
  page: {
    background: '#0e1117',
    minHeight: '100vh',
    fontFamily: "'Georgia', 'Times New Roman', serif",
    color: '#e8e0d0',
    overflowX: 'hidden',
    position: 'relative',
    paddingBottom: '4rem',
  },
  grain: {
    position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0,
    backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.75\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\' opacity=\'0.04\'/%3E%3C/svg%3E")',
    opacity: 0.6,
  },

  /* Hero */
  hero: {
    position: 'relative', zIndex: 1,
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    padding: '4rem 1.5rem 3rem',
    textAlign: 'center',
    background: 'radial-gradient(ellipse at 50% 35%, #1a2340 0%, #0e1117 65%)',
  },
  ballWrap: {
    marginBottom: '2rem',
    opacity: 0,
    animation: 'floatBob 4s ease-in-out infinite, fadeUp 0.8s ease 0.1s forwards',
  },
  eyebrow: {
    fontSize: '0.72rem', letterSpacing: '0.32em',
    textTransform: 'uppercase', color: '#c8a84b',
    margin: '0 0 0.75rem',
    opacity: 0, animation: 'fadeUp 0.8s ease 0.3s forwards',
  },
  title: {
    fontSize: 'clamp(3rem, 10vw, 6.5rem)',
    fontWeight: 900, lineHeight: 1.0, margin: '0 0 1.25rem',
    background: 'linear-gradient(135deg, #f0d060 0%, #c8853a 50%, #e8b84b 100%)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
    opacity: 0, animation: 'fadeUp 0.9s ease 0.45s forwards',
  },
  subtitle: {
    fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
    color: '#6a5a4a', lineHeight: 1.8, maxWidth: '520px',
    margin: '0 0 2.5rem', fontStyle: 'italic',
    opacity: 0, animation: 'fadeUp 0.9s ease 0.6s forwards',
  },
  btnRow: {
    display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center',
    opacity: 0, animation: 'fadeUp 0.9s ease 0.75s forwards',
  },
  btnPrimary: {
    padding: '0.8rem 2rem',
    background: 'linear-gradient(135deg, #c8a84b, #8a5a20)',
    border: 'none', borderRadius: '8px',
    color: '#0e1117', fontWeight: 800, fontSize: '1rem',
    letterSpacing: '0.04em', textDecoration: 'none',
    boxShadow: '0 4px 20px rgba(200,168,75,0.25)',
    fontFamily: "'Georgia', 'Times New Roman', serif",
    display: 'inline-block',
  },
  btnSecondary: {
    padding: '0.8rem 2rem',
    background: 'transparent',
    border: '1px solid rgba(200,168,75,0.35)', borderRadius: '8px',
    color: '#c8a84b', fontWeight: 700, fontSize: '1rem',
    letterSpacing: '0.04em', textDecoration: 'none',
    fontFamily: "'Georgia', 'Times New Roman', serif",
    display: 'inline-block',
  },

  /* Badge scroll */
  badgeTrack: {
    position: 'relative', zIndex: 1,
    overflow: 'hidden',
    borderTop: '1px solid rgba(200,168,75,0.08)',
    borderBottom: '1px solid rgba(200,168,75,0.08)',
    padding: '0.9rem 0',
    background: 'rgba(255,255,255,0.015)',
    marginBottom: '4rem',
  },
  badgeInner: {
    display: 'flex', gap: '1rem', width: 'max-content',
    animation: 'badgeScroll 18s linear infinite',
  },
  badge: {
    padding: '0.25rem 0.85rem',
    borderRadius: '4px', border: '1px solid',
    fontSize: '0.75rem', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },

  /* CTA */
  cta: {
    position: 'relative', zIndex: 1,
    textAlign: 'center',
    padding: '4rem 2rem 5rem',
    background: 'radial-gradient(ellipse at 50% 50%, #1a2340 0%, transparent 70%)',
  },
  ctaLabel: {
    fontSize: '0.72rem', letterSpacing: '0.3em',
    textTransform: 'uppercase', color: '#c8a84b', margin: '0 0 0.6rem',
  },
  ctaTitle: {
    fontSize: 'clamp(1.6rem, 5vw, 2.8rem)',
    fontWeight: 900, margin: '0 0 2rem',
    background: 'linear-gradient(135deg, #f0d060, #c8853a)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
  },

  footer: {
    position: 'relative', zIndex: 1,
    borderTop: '1px solid rgba(200,168,75,0.1)',
    padding: '2rem', textAlign: 'center',
    color: '#30281e', fontSize: '0.75rem', letterSpacing: '0.12em',
  },
};